import * as actions from 'redux/actions/keywords.actions'
import { get, hasPropertyChain } from 'helpers/util'
import getKeywordsWithNewKeyword from './getKeywordsWithNewKeyword'

const failureKeyword = state => {
  return {
    ...state,
    error: true
  }
}

const failureKeywords = (keywords, { type, payload = {} }) => {
  let updatedKeywords = {
    ...keywords
  }
  switch (type) {
    case actions.getKeywordSerpFailure.type: {
      const errors = get([payload, 'error', 'response', 'body', 'errors'], [])
      errors.forEach(item => {
        if (item.id) {
          if (!hasPropertyChain(updatedKeywords, item.id)) {
            updatedKeywords = getKeywordsWithNewKeyword(keywords, item.id)
          }
          updatedKeywords[item.id] = failureKeyword(updatedKeywords[item.id])
        }
      })
      return updatedKeywords
    }
    default:
      return updatedKeywords
  }
}

export default failureKeywords
